import { Star, Verified } from '../../assets/icons';
import React from 'react';


export const VerifiedCard = ({ rating, verified = false }) => {
  return (
    <div className="flex items-center gap-1">
      {verified && (
        <>
          <div className="w-6 h-6 rounded-lg flex items-center justify-center">
            <Verified />
          </div>
          <div className={'flex rounded-lg p-1'}>
            <span className="text-blue-500 font-semibold text-lg">VERIFICAT</span>
          </div>
        </>
      )}
      <Star className="w-7 h-7 text-yellow-400 fill-yellow-400" />
      <span className="font-bold text-gray-500 text-xl">{rating}</span>
    </div>
  );
};
